'use client';

import React from 'react';

import { useTranslations } from 'next-intl';

import {
  DEPOP_D_LOGO,
  OUTFIT_CARD_IMAGES,
  OUTFITS_UPSELL_CTA_ID,
} from './constants';
import { useOutfitsUpsellExperiment } from './useOutfitsUpsellExperiment';
import { useOutfitsUpsellTracking } from './useOutfitsUpsellTracking';

import { UpsellBanner } from '@/components/UpsellBanner';

export function OutfitsAppUpsell() {
  const t = useTranslations('home');
  const { isVariant } = useOutfitsUpsellExperiment();
  const { sendModuleView, sendCtaClick } = useOutfitsUpsellTracking();

  if (!isVariant) {
    return null;
  }

  return (
    <UpsellBanner
      headingId="outfits-upsell-heading"
      title={t('OutfitsUpsell.Title')}
      description={t('OutfitsUpsell.Description')}
      logoSrc={DEPOP_D_LOGO}
      cardImages={OUTFIT_CARD_IMAGES}
      cta={{
        label: t('OutfitsUpsell.CTA'),
        trackingId: OUTFITS_UPSELL_CTA_ID,
        onClick: sendCtaClick,
      }}
      onView={sendModuleView}
    />
  );
}
